<template>
    <div class="kosten-beheer">
        <p>Om uw pensioen te beheren, maakt een pensioenfonds kosten. Het gaat dan om kosten voor een goede administratie, het bestuur en het beheer van de beleggingen. Dit zijn de kosten van het beheer per persoon per jaar:</p>
        <div class="kosten-beheer__chart" id="kosten-beheer-container"></div>
        <p class="comment">De andere getoonde fondsen zijn de vijf fondsen die qua belegd vermogen het meest overeenkomen met het geselecteerde fonds: {{fondsSpecification}}</p>
    </div>
</template>

<script>
    import Highcharts from 'highcharts';
    import { cloneDeep, sortBy } from 'lodash';
    import { fondsSpecification } from "../modules/Utils";

    export default {
        name: "KostenBeheer",
        props: {
            fondsen: Array,
            fonds: Object
        },
        watch: {
            fondsen() {
                this.sortedFondsen = this.getSortedFondsen(this.fondsen);
                this.updateChart();
            }
        },
        computed: {
            fondsSpecification() {
                return fondsSpecification(this.sortedFondsen, this.fonds);
            }
        },
        mounted() {
            let categories;
            this.sortedFondsen = this.getSortedFondsen(this.fondsen);
            categories = this.getCategories(this.sortedFondsen);
            this.chart = Highcharts.chart('kosten-beheer-container', {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: '€'
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: '€ {point.y} per persoon per jaar'
                },
                series: [],
                credits: {
                    enabled: false
                }
            });
        },
        methods: {
            getSortedFondsen(fondsen) {
                return sortBy(fondsen, 'uitvoeringskosten');
            },
            getCategories(fondsen) {
                return fondsen ? fondsen.map(fonds => fonds.fonds) : [];
            },
            getData(fondsen) {
                const currentFondsName = this.fonds.fonds;
                return fondsen.map(fonds => {
                    const color = fonds.fonds === currentFondsName ? '#1E82FF' : '#ccc';
                    return {
                        y: fonds.uitvoeringskosten,
                        color
                    }
                });
            },
            updateChart() {
                this.chart.xAxis[0].setCategories(this.getCategories(this.sortedFondsen));
                const data = this.getData(this.sortedFondsen);
                this.chart.update({series: [{data}]}, true, true);
            }
        }
    }
</script>

<style scoped>

</style>
